<template>
  <textarea
    ref="textarea"
    v-bind="$attrs"
    v-model="value"
    :class="['form-control', small ? 'form-control-sm' : '']"
    :style="`resize:none; min-height:${minHeight}px; max-height:${maxHeight}px`"/>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: String,
    maxRows: {
      type: Number,
      default: () => 4
    },
    minRows: {
      type: Number,
      default: () => 2
    },
    small: Boolean
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
    lineHeight() {
      return this.small ? 19 : 24;
    },
    minHeight() {
      return this.minRows * this.lineHeight + 12;
    },
    maxHeight() {
      return this.maxRows * this.lineHeight + 12;
    }
  },
  mounted() {
    this.updateSize();
  },
  watch: {
    modelValue() {
      this.updateSize();
    }
  },
  methods: {
    updateSize() {
      this.$refs.textarea.style.height = "auto";
      this.$nextTick(() => {
        let h = this.$refs.textarea.scrollHeight;
        if (h < this.minHeight + this.lineHeight) {
          // The textarea, by default, does not allow a single row. This overrides that by catching if the natural
          // height is in between 1 and 2 rows, and overriding it to exactly one row.
          h = this.minHeight;
        }
        this.$refs.textarea.style.height = h + 'px';
      });
    }
  }
}
</script>
